import React from "react";
import useIsMounted from "../../../../../hooks/use-is-mounted";
import SendOrderEmail, {SendOrderEmailTextTypes} from "../../../send-order-email";

const PayCustomerOrderSendEmailSection = ({
                                              state,
                                              onEmailSent,
                                              formId,
                                              setSubmitting,
                                              customerId,
                                          }) => {
    const isMounted = useIsMounted();

    /**
     * Submits the form with the given email value to be sent to the api.
     * @param values
     */
    const sendEmail = async (values) => {
        if (!values?.email || !state?.send)
            return
        setSubmitting(true);
        const resultFlag = await state?.send?.(values.email, values.includeBcc);
        if (!isMounted())
            return
        setSubmitting(false);
        if (resultFlag) {
            onEmailSent();
        }
    }

    return (
        <>
            <SendOrderEmail
                customerId={customerId}
                submit={sendEmail}
                textType={SendOrderEmailTextTypes.payment}
                formId={formId}
            />
        </>
    )
}

export default PayCustomerOrderSendEmailSection;
